import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import { renderTitle, renderList } from './menu-utils';

class SubMenu extends PureComponent {
  handleClickOutside = event => {
    this.props.onClickOutside(event);
  };

  handleSubMenuClick = event => {
    this.props.onSubMenuClick(event);
  };

  render() {
    const { email, children, isVisible, isTest, menu } = this.props;
    const subMenuStyle = `${
      isTest ? 'db' : `${isVisible ? 'dn db-l' : 'dn'}`
    } absolute left-0 z-5 ph4 w-100 bg-white bb b--black-10`;
    const styleObj = {
      marginTop: '0.0625rem',
      top: isTest ? '0' : '100%',
    };

    if (!menu) {
      return null;
    }

    return (
      <div className={`sub-menu ${subMenuStyle}`} style={styleObj}>
        {!children ? (
          <div className="mw9 center pv3">
            <div className="flex nl4 nr4">
              {menu.map(menuItem => (
                <section
                  key={`mega-nav-sub-menu-section-${menuItem.label}`}
                  className="w-50 ph4"
                  data-id={`mega-nav-sub-menu-section-${menuItem.label}`}
                >
                  {renderTitle({
                    label: menuItem.label,
                    secondaryLabel: menuItem['secondary-label'],
                    entity: menuItem.entity,
                  })}
                  {renderList(
                    {
                      email,
                      list: menuItem.items,
                      gutterSpacing: null,
                    },
                    false,
                    this.handleSubMenuClick,
                  )}
                  <div className="w-100 flex">
                    {menuItem.items
                      ? menuItem.items.map((secondaryItem, index) => (
                          <div
                            key={`secondary-item ${secondaryItem.label}`}
                            className={`
                        ${!secondaryItem.items ? 'dn' : ''}
                        ${index !== menuItem.items.length - 1 ? 'pr4' : ''} w-50`}
                          >
                            {secondaryItem.items ? (
                              <div>
                                {renderTitle(
                                  {
                                    label: secondaryItem.label,
                                    secondaryLabel: secondaryItem['secondary-label'],
                                    entity: secondaryItem.entity,
                                  },
                                  true,
                                )}
                                {renderList(
                                  {
                                    email,
                                    list: secondaryItem.items,
                                    gutterSpacing: null,
                                  },
                                  false,
                                  this.handleSubMenuClick,
                                )}
                              </div>
                            ) : null}
                          </div>
                        ))
                      : null}
                  </div>
                </section>
              ))}
            </div>
          </div>
        ) : (
          <div>{children}</div>
        )}
      </div>
    );
  }
}

SubMenu.propTypes = {
  children: PropTypes.node,
  email: PropTypes.string,
  isVisible: PropTypes.bool,
  isTest: PropTypes.bool,
  menu: PropTypes.arrayOf(PropTypes.shape({})),
  onClickOutside: PropTypes.func,
  onSubMenuClick: PropTypes.func,
};

SubMenu.defaultProps = {
  children: null,
  email: null,
  isVisible: null,
  isTest: false,
  menu: null,
  onClickOutside: () => {},
  onSubMenuClick: () => {},
};

export default onClickOutside(SubMenu);
